<template>
  <div>
    <v-card v-if="showTable">                 
      <v-data-table
        v-model="preparedData.invoices"
        :headers="description_headers"
        :items="payment_invoices"
        :loading="loading"
        loader-height="2"
        show-select
        class="elevation-0 table-org sr-pl-sh-table"
        item-key="invoice_id"
        hide-default-footer
        mobile-breakpoint="100"
        >
        <template v-slot:item="{item, isSelected, select}">
          <tr :key="item.invoice_id">
            <td style="max-width: 52px;">
              <v-simple-checkbox
                :value="isSelected"
                :ripple="false"
                color="primary"
                @input="select($event)">
              ></v-simple-checkbox>
            </td>           
            <td>{{ item.invoice_number }}</td>
            <td>{{ timeFormat(item.created_at) }}</td>
            <td>${{ item.invoice_total }}</td>
            <td>${{ item.remaining }}</td>
            <!-- <td>${{ item.amount }}</td> -->
            <td>
              <v-text-field
                outlined
                single-line
                v-model="preparedDataInvoices[`slug_${item.invoice_id}`].amount"
                label="Payment"
                placeholder="0.00"
                prepend-icon="attach_money"
                class="check-input-text check-input-amount"
                :error-messages="errors($v.preparedDataInvoices[`slug_${item.invoice_id}`].amount)"
                @blur="$v.preparedDataInvoices[`slug_${item.invoice_id}`].amount.$touch()"
                @change="selectInvoice(item, preparedDataInvoices[`slug_${item.invoice_id}`].amount)"
              >
              </v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
      <template v-if="!loading">
        <v-divider></v-divider>
        <div class="px-6">
          <v-alert class="pa-2 mt-4 xs12" :value="$v.preparedDataInvoices.$error" outlined color="error" icon="priority_high" transition="scale-transition">
            <span class="caption">Please fill out form correctly.</span>    
          </v-alert>
          <v-alert class="pa-2 mt-4 xs12" :value="!$v.preparedDataInvoices.$error && $v.preparedDataInvoices.$dirty && !correctAmount" outlined color="error" icon="priority_high" transition="scale-transition">
            <span class="caption">{{ correctAmountMessage }}</span>    
          </v-alert>
          <v-alert class="pa-2 mt-4 xs12" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
            <span class="caption">{{ serverValidationMessage }}</span>    
          </v-alert>
        </div>
        <v-layout class="px-6 py-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="my-0 ml-2" text @click="close">Cancel</v-btn>
          <v-btn
            @click="UpdatePayment" 
            :disabled="saveLoading"
            :loading="saveLoading"
            color="primary" 
            class="my-0 mr-0 ml-2">Save</v-btn>
        </v-layout>
      </template>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { validationMixin } from "vuelidate";
import { required, decimal, helpers } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages";
import { mapGetters, mapActions } from "vuex";

let validations = {}

export default {
  name: 'UpdatePayment',
  mixins: [validationMixin],
  validations() {
    validations = {
      preparedDataInvoices: {}
    };
    Object.values(this.preparedDataInvoices).forEach(i => {
      validations.preparedDataInvoices[`slug_${i.invoice_id}`] = { amount: {}}
      if(this.preparedData.invoices.some(s => s.invoice_id === i.invoice_id)) {
        validations.preparedDataInvoices[`slug_${i.invoice_id}`].amount.shortRequired = required
        validations.preparedDataInvoices[`slug_${i.invoice_id}`].amount.decimal = decimal
        validations.preparedDataInvoices[`slug_${i.invoice_id}`].amount.notValid = v => !helpers.req(v) || v >= 0
        validations.preparedDataInvoices[`slug_${i.invoice_id}`].amount.currency = v => !helpers.req(v) || /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(v) || /^0+(\.[0-9]{1,2})?$/.test(v)
      }
    })
    this.errors = getValMessage(valMessages)(validations);
    return validations;
  },
  data: () => ({
    no_data: [null, '', undefined, 'null'],
    description_headers: [
      {
        text: 'Description',
        align: 'left',
        sortable: false,
        value: 'invoice_number',            
      },
      {
        text: 'Due Date',            
        sortable: false,
        value: 'date',            
      },
      {
        text: 'Original Amount',            
        sortable: false,
        value: 'amount',           
      },
      {
        text: 'Open Balance',            
        sortable: false,
        value: 'amount', 
      },
      {
        text: 'Payment',            
        sortable: false,
        value: 'amount'
      }        
    ],
    showTable: false,
    payment: null,
    payment_invoices: [],
    loading: false,
    preparedData: {},
    preparedDataInvoices: {},
    saveLoading: false,
    correctAmountMessage: '',
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {},
    unsubscribe: null
  }),  
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'UpdatePayment') {
          this.open(action.payload.data)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    open(item) {
      this.payment = item.payment
      this.resetServerValidation();
      this.$v.$reset()
      this.payment_invoices = []
      this.preparedData = {}
      this.preparedDataInvoices = {}
      let payment_invoices = []
      let preparedData = {}
      let preparedDataInvoices = {}

      payment_invoices = item.payment_invoices
      preparedData = {
        check_amount: Number(item.payment.amount) - Number(item.payment.amount_refunded),
        payment_id: item.payment.id,
        invoices: _.cloneDeep(item.payment_invoices)
      };
      preparedDataInvoices = {}
      payment_invoices.forEach(i => {
        i.amount = parseFloat(i.amount).toFixed(2)
        preparedDataInvoices[`slug_${i.invoice_id}`] = i
      })
      this.getUnpayedInvoices(item.payment)
        .then(response => {
          let invoices = []
          invoices = _.cloneDeep(response.invoices)
          invoices = invoices.map(i => ({
            amount: (i.remaining).toFixed(2),
            created_at: i.created_at,
            invoice_id: i.id,
            invoice_number: i.invoice_number,
            remaining: i.remaining,
            invoice_total: i.total,
          }))
          invoices.forEach(i => {
            if(!payment_invoices.some(item => item.invoice_id === i.invoice_id)) {
              preparedDataInvoices[`slug_${i.invoice_id}`] = {...i}
              payment_invoices.push(i)
            }
          })
          this.payment_invoices = _.cloneDeep(payment_invoices)
          this.preparedData = _.cloneDeep(preparedData)
          this.preparedDataInvoices = _.cloneDeep(preparedDataInvoices)
        })
        .catch(error => {
          this.payment_invoices = payment_invoices
          this.preparedData = preparedData
          this.preparedDataInvoices = preparedDataInvoices
        })
      this.showTable = true;
      this.saveLoading = false;
    },
    getUnpayedInvoices(payment) {
      let body, url
      if(!this.no_data.includes(payment.client_id)) {
        body = { client_id: payment.client_id }
        url = '/payment/un_payed_invoices'
      } else {
        body = { 
          commercial_location_id: payment.commercial_location_id,
          organization_id: this.user.organization_id
        }
        url = '/commercial/payment/un_payed_invoices'
      }
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(url, body)
          .then(response => {
            this.loading = false
            let data = response.data;
            resolve(data);
          })
          .catch(erorr => {
            this.loading = false
            reject(error)
            console.log(error);
          })
      })
    },
    UpdatePayment() {
      this.resetServerValidation()
      this.$v.preparedDataInvoices.$touch();
      if (!this.$v.preparedDataInvoices.$invalid && this.correctAmount) {
        this.saveLoading = true;
        let body = {
          check_amount: this.preparedData.check_amount,
          payment_id: this.preparedData.payment_id,
          invoices: this.preparedData.invoices.map(i => ({id: i.invoice_id, payment: Number(this.preparedDataInvoices[`slug_${i.invoice_id}`].amount)}))
        }
        // console.log(body)
        ApiService.put('/payment/update', body)
          .then(response => {
              this.saveLoading = false
              this.vEmit({ 
                name: "notification", 
                data: {
                  status: 'success', 
                  text: 'Payment has been successfully edited.'
                }
              })
              this.showTable = false
              this.$emit('done')
          })
          .catch(({ response }) => {
              this.saveLoading = false
              this.serverValidation = false
              if (response.data.error) {
                this.serverValidationMessage = this.titleCase(response.data.error);
              }
              if (response.data.message) {
                this.serverValidationMessage = response.data.message;
              }
              if (response.data.errors) {
                this.server_errors = response.data.errors;
              }
          })
      }
    },
    close() {
      this.showTable = false
      this.$emit('close')
    },
    selectInvoice(item, amount) {
      if(!this.no_data.includes(amount)) {
        if(Number(amount) > 0) {
          if(!this.preparedData.invoices.some(i => i.invoice_id === item.invoice_id)) {
            this.preparedData.invoices.push(item)
          }
        } else {
          this.preparedData.invoices = this.preparedData.invoices.filter(i => i.invoice_id !== item.invoice_id)
        } 
      }
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
      this.server_errors = {}
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    toggleAll () {
      if (this.preparedData.invoices.length) this.preparedData.invoices = []
      else this.preparedData.invoices = this.payment_invoices;
    },
    timeFormat(date) {
      return moment(date).format('MMM DD, YYYY HH:mm');
    },
    round (n) {
      return (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2)
    },
    errors: getValMessage(valMessages)(validations)
  },
  computed: {
    ...mapGetters(['user']),
    correctAmount() {
      if(this.preparedData && typeof this.preparedData.invoices === 'object') {
        let invoices = this.preparedData.invoices.map(i => ({payment: Number(this.preparedDataInvoices[`slug_${i.invoice_id}`].amount)}))
        let invoicesSum = 0.0
        invoices.forEach(i => {
          if(!this.no_data.includes(i.payment) && typeof parseFloat(i.payment) === "number") {
            invoicesSum += parseFloat(i.payment)
          }
        })
        if (this.preparedData.check_amount >= invoicesSum) {
          this.correctAmountMessage = ''
          return true
        } else {
          this.correctAmountMessage = `Sum of all selected invoices ($${this.round(invoicesSum)}) must be less or equal to payment amount ($${this.round(this.preparedData.check_amount)})`
          return false
        }
      } else {
        this.correctAmountMessage = ''
        return true
      }
    }
  }
}
</script>

<style>

  /*Input text fields*/
   .check-input-text .v-input__slot{
    min-height: 25px !important;
    border-radius: 3px !important;
    border: 0px solid!important;
    /* border: 1px solid!important; */
    margin: 17px 0px 0px 0px;

  }
  .check-input-text:not(.primary--text):not(.error--text) .v-input__slot{
    border: 0px solid lightgray!important;
  }
  .check-input-text.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 5px 0px 0px;
  }
  .check-input-text .v-input__slot .v-text-field__slot input{
    margin: 0px;
    font-size: 13px;
  }

   .check-input-text .v-input__prepend-outer{
     margin-top: 22px !important;
     margin-right: 0px;
   }

  .check-input-text .v-icon{
    font-size: 20px;
  }
  .check-input-amount .v-input__slot{
    max-width: 150px;
    min-width: 75px;
  }

</style>